export function SelectArrowDown() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path d="M8.5859 0C9.47658 0.000202034 9.92265 1.07711 9.29293 1.70703L5.70699 5.29297C5.31651 5.68343 4.68346 5.68336 4.29293 5.29297L0.706993 1.70703C0.0770795 1.07707 0.523166 4.10258e-05 1.41402 0H8.5859Z" fill="#949494" />
  </svg>
}

export function SelectArrowTop() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path d="M3.88088 0.292068L0.295097 3.87785C-0.334867 4.50782 0.1113 5.58496 1.0022 5.58496L8.17378 5.58496C9.06468 5.58496 9.51085 4.50782 8.88088 3.87785L5.2951 0.292068C4.90457 -0.0984564 4.27141 -0.0984564 3.88088 0.292068Z" fill="#949494" />
  </svg>
}